<template>
  <div class="home">
      <Header active="home"></Header>
      <el-carousel height="430px">
          <el-carousel-item v-for="item in bannerList" v-bind:key="item.id">
              <img class="banner-img" :src="item.img" v-bind:class="{'pointer': item.clickable}" @click="onBannerClick(item)" />
          </el-carousel-item>
      </el-carousel>
      <el-row class="spacing-up">
          <h1>新闻中心</h1>
      </el-row>
      <el-row :gutter="30" class="container">
          <el-col v-for="item in newsList" v-bind:key="item.id" :span="8">
              <el-card class="card-item news-card" :body-style="{height: '100%'}" shadow="hover">
                  <el-image class="news-img" :src="item.image"></el-image>
                  <el-row class="news-align">
                      <h3 class="news-title" @click="toNewsDetail(item.id)">{{item.title}}</h3>
                  </el-row>
                  <el-row class="news-align news-summary">
                          {{item.summary}}
                  </el-row>
                  <!--<el-row class="news-button">-->
                      <el-button class="news-button"  plain @click="toNewsDetail(item.id)">详细信息</el-button>
                  <!--</el-row>-->
              </el-card>
          </el-col>
      </el-row>
      <!--<el-row :gutter="30" class="container notice-container">-->
          <!--<el-col :span="8">-->
              <!--<el-card class="card-item" shadow="hover">-->
                  <!--<div class="corner"></div>-->
                 <!--<h1>通知公告</h1>-->
                  <!--<p class="notice-first-summary">-->
                      <!--{{firstNotice.summary}}-->
                  <!--</p>-->
                  <!--<el-button plain @click="toNewsDetail(firstNotice.id)">详细信息</el-button>-->
              <!--</el-card>-->
          <!--</el-col>-->
          <!--<el-col :span="16" class="notice-list">-->
            <!--<el-row v-for="item in noticeList" :key="item.id" class="notice-item" @click.native="toNewsDetail(item.id)">-->
                <!--<el-col :span="18" class="notice-content">-->
                    <!--{{item.title}}-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<span class="right notice-time">{{convertTime(item.createTime)}}</span>-->
                <!--</el-col>-->
            <!--</el-row>-->
              <!--<el-row class="notice-item">-->
                  <!--<el-button class="right" plain @click="toNews">查看更多</el-button>-->
              <!--</el-row>-->
          <!--</el-col>-->
      <!--</el-row>-->

      <el-row class="spacing-up">
          <h1>解决方案</h1>
      </el-row>
      <el-row>
          <el-row class="icon-container">
              <el-col :span="2" class="business-icon"></el-col>
              <el-col :span="4" class="business-icon" :class="{'business-icon-selected': isSelected(1)}">
                  <div @click="selectedIcon = 1">
                      <!--<i class="el-icon-thirdComputer" ></i>-->
                      <img v-if="! isSelected(1)" class="solution-title-img" src="../../assets/imgs/business/sanhetongyun1.png" >
                      <img v-if="isSelected(1)" class="solution-title-img" src="../../assets/imgs/business/sanhetongyun2.png" >
                  </div>
                  <div @click="selectedIcon = 1" class="solution-title-text">
                      <span>三合通云</span>
                  </div>
              </el-col>

              <el-col :span="4" class="business-icon" :class="{'business-icon-selected': isSelected(2)}">
                  <div @click="selectedIcon = 2">
                      <!--<i class="el-icon-thirdzhinengzhuangbei" ></i>-->
                      <img v-if="! isSelected(2)" class="solution-title-img" src="../../assets/imgs/business/智慧农业1.png" >
                      <img v-if="isSelected(2)" class="solution-title-img" src="../../assets/imgs/business/智慧农业2.png" >
                  </div>
                  <div @click="selectedIcon = 2" class="solution-title-text">
                      <span>智慧农业</span>
                  </div>
              </el-col>

              <el-col :span="4" class="business-icon" :class="{'business-icon-selected': isSelected(3)}">
                  <div @click="selectedIcon = 3">
                      <!--<i class="el-icon-thirdgongyede-" ></i>-->
                      <img v-if="! isSelected(3)" class="solution-title-img" src="../../assets/imgs/business/智能装备1.png" >
                      <img v-if="isSelected(3)" class="solution-title-img" src="../../assets/imgs/business/智能装备2.png" >
                  </div>
                  <div @click="selectedIcon = 3" class="solution-title-text">
                      <span>智能装备</span>
                  </div>
              </el-col>
              <el-col :span="4" class="business-icon" :class="{'business-icon-selected': isSelected(4)}">
                  <div @click="selectedIcon = 4">
                      <!--<i class="el-icon-thirdgongyesheji" ></i>-->
                      <img v-if="! isSelected(4)" class="solution-title-img" src="../../assets/imgs/business/智慧城市1.png" >
                      <img v-if="isSelected(4)" class="solution-title-img" src="../../assets/imgs/business/智慧城市2.png" >
                  </div>
                  <div @click="selectedIcon = 4" class="solution-title-text">
                      <span>智慧城市</span>
                  </div>
              </el-col>
              <el-col :span="4" class="business-icon" :class="{'business-icon-selected': isSelected(5)}">
                  <div @click="selectedIcon = 5">
                      <!--<i class="el-icon-thirdgongyesheji" ></i>-->
                      <img v-if="! isSelected(5)" class="solution-title-img" src="../../assets/imgs/business/合作1.png" >
                      <img v-if="isSelected(5)" class="solution-title-img" src="../../assets/imgs/business/合作2.png" >
                  </div>
                  <div @click="selectedIcon = 5" class="solution-title-text">
                      <span>合作解决方案</span>
                  </div>
              </el-col>
              <el-col :span="2" class="business-icon"></el-col>
          </el-row>



        <el-row class="solution-container" v-if="isSelected(1)">
            <el-col :span="12" class="solution-item solution-item-text-left">

                <div class="corner-rigth"></div>
                <el-row class="solution-item-margin">
                    <h1>三合通云</h1>
                </el-row>
                <el-row class="solution-item-margin">
                    <p class="solution-item-p">
                        三合通云：拥有完备的云基础架构，将云计算、物联网、大数据、人工智能、5G、北斗等新技术与智慧农业、智能装备和智慧旅游等智慧产业深度融合，搭建三产融合大数据平台，促进一、二、三产业形成高附加值闭环数据链条，为用户精准决策提供服务。
                    </p>
                </el-row>
            </el-col>
            <el-col :span="12" class="solution-item">
                <el-carousel height="350px">
                    <el-carousel-item v-for="item in shtybannerList" v-bind:key="item.id">
                        <img class="banner-img" :src="item.img" v-bind:class="{'pointer': item.clickable}" @click="onBannerClick(item)" />
                    </el-carousel-item>
                </el-carousel>
            </el-col>
        </el-row>
      </el-row>

      <el-row class="solution-container" v-if="isSelected(2)">
        <el-col :span="12" class="solution-item solution-item-text-left">

            <div class="corner-rigth"></div>
            <el-row class="solution-item-margin">
                <h1>生态无人农场</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    是现代农艺和农机装备、绿色植保技术、无人机、机器人、人工智能、物联网、大数据、云计算、3S、5G、
                    北斗等高新技术集成的成果，将依托各种传感器节点和网络，通过天、地、空一体化信息监测系统获取农情信息，
                    采用地空一体化智能农业机器人和农业装备等协同作业，实现农业生产环境的智能感知、智能分析、智能决策、
                    智能预警等功能，达到绿色生态农业生产的精准化种植，可视化管理、智能化操控和生态化保护，打造可复制易推广的
                    绿色生态、高效环保的循环无人农场新模式。
                </p>
            </el-row>
        </el-col>
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/stwrnc1.png" />
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(2)">
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/stwrncyddn1.png" />
        </el-col>
        <el-col :span="12" class="solution-item solution-item-text-right">

            <div class="corner-left"></div>
            <el-row class="solution-item-margin">
                <h1>生态无人农场云端大脑</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    由山东理工大学生态无人农场研究院和三合通科技共同开发的应用服务平台，该平台充分利用大数据、云计算、AI识别、
                    3S技术和区块链技术，通过农场罗盘、数据驾驶舱、智能监测、智能决策、智能作业、智能管理、模型库、智慧科研、
                    智慧溯源、产业链赋能服务等功能模块，实现生态无人农场的数字化、联网化、智能化、无人化管理，为打造精准、无人、
                    高效、低成本和绿色环保的智慧农业新模式提供一体化管理平台。
                </p>
            </el-row>
        </el-col>
      </el-row>

      <el-row class="solution-container" v-if="isSelected(3)">
        <el-col :span="12" class="solution-item solution-item-text-left">

            <div class="corner-rigth"></div>
            <el-row class="solution-item-margin">
                <h1>智能农机装备整体解决方案</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    公司具有专业的智能装备研发团队，能够提供从线控底盘、线控改制、自动驾驶算法、高精度地图构建、自动驾驶零部件、
                    自动驾驶整机端到端一体化解决方案。具体包括农机无人驾驶系统、农机辅助驾驶系统和农业机器人系统。
                </p>
            </el-row>
        </el-col>
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/znzbztjjfa1.png" />
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(3)">
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/znzbykpt1.png" />
        </el-col>
        <el-col :span="12" class="solution-item solution-item-text-right">

            <div class="corner-left"></div>
            <el-row class="solution-item-margin">
                <h1>智能装备云控平台</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    为生态无人农场地空一体化农业机器人、无人机和智能农机装备等协同作业提供规范、可靠的服务管理支撑，保证
                    无人机、农业机器人和智能农机等智能装备的安全可控。
                </p>
            </el-row>
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(3)">
        <el-col :span="12" class="solution-item solution-item-text-left">

            <div class="corner-rigth"></div>
            <el-row class="solution-item-margin">
                <h1>智能网联农机</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    智能网联农机在云端大脑的操控下根据农艺处方生成不同模式进行自主作业。可实现智能识别、自主决策、自主作业等动作并对各类农机具进行自动操控。
                </p>
            </el-row>
        </el-col>
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/znwlnj1.png" />
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(3)">
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/nyjqr1.png" />
        </el-col>
        <el-col :span="12" class="solution-item solution-item-text-right">

            <div class="corner-left"></div>
            <el-row class="solution-item-margin">
                <h1>农业机器人</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    农业机器人是一种由不同软件系统控制，采用多光谱三维成像方法、深度学习农作物识别方法、视觉定位模式
                    的全自动的农作物采摘方法等先进技术，能感觉并适应农作物种类或环境变化，具备监测、演算和自学习等人工
                    智能技术的新一代无人自动操作机器。可应用农业生产过程中的巡检、除草、施肥、采摘等场景。
                </p>
            </el-row>
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(3)">
        <el-col :span="12" class="solution-item solution-item-text-left">

            <div class="corner-rigth"></div>
            <el-row class="solution-item-margin">
                <h1>智能环保装备</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    智能生态循环利用系列产品-生物质热解处理器以及无动力粪污（有机垃圾）离子矿化处理器，遵循了对自然资源
                    （畜禽粪污和有机垃圾）-清洁生产-日清日洁-绿色消费-再生能源的生态模式，在实现畜牧养殖业粪污日清日洁、
                    以废治废、循环利用的同时，可降低养殖成本、增加养殖户的收入。
                </p>
            </el-row>
        </el-col>
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/znhbzb1.png" />
        </el-col>
      </el-row>

      <el-row class="solution-container" v-if="isSelected(4)">
        <el-col :span="12" class="solution-item solution-item-text-left">

            <div class="corner-rigth"></div>
            <el-row class="solution-item-margin">
                <h1>十四五规划平台</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    “十四五”规划全生命周期数字化服务云平台包括规划评估中枢、产业数字地图、重大项目驾驶舱、重点任务监控台
                    和规划管理服务台五大模块，可有效促进政府部门的信息资源互联共享，提高政府宏观把握能力和科学决策能力，
                    实现十四五规划全生命周期的数字化管理。
                </p>
            </el-row>
        </el-col>
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/sswghpt1.png" />
        </el-col>
      </el-row>
      <el-row class="solution-container" v-if="isSelected(4)">
        <el-col :span="12" class="solution-item">
            <img src="https://www.ccsht.cn/resources/static/images/zhnycn1.png" />
        </el-col>
        <el-col :span="12" class="solution-item solution-item-text-right">

            <div class="corner-left"></div>
            <el-row class="solution-item-margin">
                <h1>智慧农业超脑</h1>
            </el-row>
            <el-row class="solution-item-margin">
                <p class="solution-item-p">
                    通过采集环境及作物监测设备数据、智能网联农机作业数据、农业全过程作业数据，建立数据分析模型，给
                    农业管理部门和农业经营主体提供精准有效的服务，为城市大脑提供智慧农业应用的监管和决策数据。
                </p>
            </el-row>
        </el-col>
      </el-row>

      <el-row class="solution-container" v-if="isSelected(5)">
            <el-col :span="12" class="solution-item">
                <img src="https://www.ccsht.cn/resources/static/images/06%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9E.jpg" />
            </el-col>
            <el-col :span="12" class="solution-item solution-item-text-right">

                <div class="corner-left"></div>
                <el-row class="solution-item-margin">
                    <h1>科大讯飞</h1>
                </el-row>
                <el-row class="solution-item-margin">
                    <p>
                        三合通科技的战略投资合作伙伴之一，科大讯飞专业从事智能语音及语言技术研究、软件及芯片产品开发、语音信息服务及电子政务系统集成等 。在语音合成、语音识别、口语评测、语言翻译、声纹识别、人脸识别、自然语言处理等智能语音与人工智能核心技术上代表国际先进水平。
                    </p>
                </el-row>
            </el-col>
        </el-row>



        <el-row class="solution-container" v-if="isSelected(5)">
            <el-col :span="12" class="solution-item solution-item-text-left">

                <div class="corner-rigth"></div>
                <el-row class="solution-item-margin">
                    <h1>北京百分点</h1>
                </el-row>
                <el-row class="solution-item-margin">
                    <p>
                        三合通科技的战略投资合作伙伴之一，是国内大数据公司第一梯队的龙头企业，拥有完整的大数据和认知智能产品线，以及行业智能决策应用产品。目前已服务国内外10,000+企业与政府客户，致力于推进数据到知识再到智能决策的演进。
                    </p>
                </el-row>
            </el-col>
            <el-col :span="12" class="solution-item">
                <img src="https://www.ccsht.cn/resources/static/images/07%E5%8C%97%E4%BA%AC%E7%99%BE%E5%88%86%E7%82%B9.jpg" />
            </el-col>
        </el-row>
      

      <div style="line-height: 0;margin-top: 60px;margin-bottom: 20px;">
          <img src="../../assets/imgs/home/partner/partner.png" style="width: 88%; height: auto;">
      </div>

      <div style="line-height: 0;margin-top: 60px;margin-bottom: 20px;">
          <img src="../../assets/imgs/home/honor.png" style="width: 88%; height: auto;">
      </div>
    
      <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {newsApi} from "../../api/news-api";
import {formatFromTimeString} from "../../utils/date";
import {global} from "@/utils/global";

export default {
  name: 'PCHome',
  components: {
      Header,
      Footer
  },
    data() {
      return {
          selectedIcon: 1,
          newsList: [],
          noticeList: [],
          firstNotice: {},
          bannerList: [
            //   {
            //       id: 0,
            //       img: `${global.RESOURCE_PREFIX}/images/banner1.jpg`,
            //       clickable: false
            //   },
              {
                  id: 1,
                  img: `${global.RESOURCE_PREFIX}/images/banner2.jpg`,
                  clickable: false
              },
              {
                  id: 2,
                  img: `${global.RESOURCE_PREFIX}/images/banner3.jpg`,
                  clickable: false
              },
              {
                  id: 3,
                  img: `${global.RESOURCE_PREFIX}/images/banner4.jpg`,
                  clickable: true,
                  businessName: 'data'
              }
          ],
          shtybannerList: [
              {
                  id: 0,
                  img: `${global.RESOURCE_PREFIX}/images/sanhetongyun1.png`,
                  clickable: false
              },
              {
                  id: 1,
                  img: `${global.RESOURCE_PREFIX}/images/sanhetongyun2.png`,
                  clickable: false
              }
          ]
      }
    },
    mounted () {
      this.listNews();
      this.listNotice();
    },
    methods: {
      isSelected (index) {
          return this.selectedIcon === index;
      },
        listNews () {
            newsApi.list({
                type: 1,
                status: 1,
                page: 1,
                limit: 3
            }).then(res => {
                if (res.code === 200) {
                    this.newsList = res.page.list;
                }
            })
        },
        listNotice () {
            newsApi.list({
                type: 2,
                status: 1,
                page: 1,
                limit: 6
            }).then(res => {
                if (res.code === 200) {
                    const list = res.page.list;
                    if (list && list.length > 0) {
                        this.noticeList = list.slice(1, list.length);
                        this.firstNotice = list[0];
                    }
                }
            })
        },
        toNewsDetail (id) {
          this.$router.push({
              path: `/news/${id}`
          })
        },
        toNews () {
          this.$router.push({
              path: '/news'
          })
        },
        toBusiness (businessName) {
            const routeParams = {
                path: '/business'
            };
            if (businessName) {
                routeParams.query = {
                    businessName: businessName
                };
            }
            this.$router.push(routeParams);
        },
        onBannerClick (item) {
          if (! item.clickable) {
              return;
          }
          if (item.businessName) {
              this.toBusiness(item.businessName);
          }
        }
    },
    computed: {
      convertTime () {
          return function (time) {
              return formatFromTimeString(time);
          }
      }
    }
}
</script>
<style scoped>
    .home {
        height: 100%;
        width: 100%;
    }
    .banner-img {
        width: 100%;
        height: 500px;
        object-fit: fill;
    }
    .container {
        padding: 0 50px;
    }
    .card-item {
        width: 100%;
        background-color: rgb(244, 244, 244);
    }
    .news-img {
        width: 100%;
        max-height: 240px;
    }
    .notice-container {
        height: 40%;
        margin-top: 50px;
    }
    .notice-content {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }
    .notice-list {
        height: 100%;
    }
    .notice-item {
        height: 13%;
        cursor: pointer;
    }
    .right {
        float: right;
    }
    .business-icon {
        text-align: center;
        height: 120px;
    }
    .business-icon i {
        font-size: 50px;
        /*height: 90px;*/
    }
    .icon-container {
        /* margin: 0 10%; */
    }
    .business-icon.business-icon-selected {
        /* border-bottom: 5px solid #ff4e00; */
        color: #ff4e00;
    }
    .business-icon.business-icon-selected i {
        color: #ff4e00;
    }
    .business-content {
        width: 100%;
        height: 500px;
        background: url("../../assets/imgs/home/city.jpg") no-repeat;
        background-size: 100% 100%;
        color: #ffffff;
    }
    .business-text-container {
        height: 100%;
        margin-left: 20%;
        margin-right: 10%;
        text-align: left;
        padding: 30px 0;
    }
    .business-button {
        width: 120px;
    }
    .business-title {
        font-size: 36px;
        margin-top: 70px;
    }
    .business-blue {
        color: #409EFF;
    }
    .business-text {
        font-size: 18px;
    }
    .primary {
        color: #ff4e00;
    }
    .partner-container {
        width: 100%;
        /*height: 400px;*/
        background: url("../../assets/imgs/home/partner/生态伙伴.jpg") no-repeat;
        background-size: 100% auto;
    }

    .parter-row {
        height: 30%;
        width: 100%;
    }

    .partner-item {
    }

    .parter-item img {
        height: 60px;
        width: 180px;
    }

    .parter-text {
        /*color: #ffffff;*/
        font-size: 24px;
        color: #777777;
    }
    .corner {
        width: 0;
        height: 0;
        border-top: 70px solid #ff4e00;
        border-right: 70px solid transparent;
        position: absolute;
        top: 0;
        left: 70px;
        z-index: 99;
    }

    .news-align {
        text-align: left;
    }

    .news-title {
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:2;
        -webkit-box-orient:vertical;
        cursor: pointer;
    }

    .news-summary {
        font-size: 15px;
        line-height: 25px;

        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:4;
        -webkit-box-orient:vertical;
    }

    .news-card {
        /*height: 600px;*/
        min-height: 520px;
    }

    .news-button {
        position: absolute;
        bottom: 0;
        transform: translate(-50%, -50%);
    }

    .notice-first-summary {
        font-size: 15px;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: left;
    }

    .notice-time {
        font-size: 14px;
        color: #777777;
    }

    .notice-item:hover {
        color: #ff4e00;
    }

    .notice-item:hover .notice-time {
        color: #ff4e00;
    }

    .spacing-up {
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .pointer {
        cursor: pointer;
    }
    .news-title:hover {
        color: #ff4e00;
    }
    
    .solution-title-img {
        height: 60px;
    }
    .solution-title-text {
        margin-top: 10px;
    }

    .solution-container {
        width: 100%;
        height: 350px;
    }
    .solution-item {
        height: 100%;
    }
    .solution-item-text-right {
        text-align: left;
        /*padding: 0 60px;*/
        background: #f8f8f8;
    }
    .solution-item-text-left {
        text-align: left;
        /*padding: 0 60px;*/
        background: #f8f8f8;
    }
    .solution-item img {
        width: 100%;
        height: 350px;
    }
    .corner-left {
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-right: 30px solid #fff;
        border-bottom: 20px solid transparent;
        z-index: 100;
        position: relative;
        left: -30px;
        top: 140px;
        float: left;
    }
    .corner-rigth {
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-left: 30px solid #fff;
        border-bottom: 20px solid transparent;
        z-index: 100;
        position: relative;
        right: -30px;
        top: 140px;
        float: right;
    }
    .solution-item-margin {
        margin-left: 60px;
        margin-right: 60px;
    }
    .solution-item-margin h1 {
        margin-top: 40px;
    }
    .solution-item.solution-item-text-right:hover {
        background: #ff4e00;
        color: #ffffff;
    }
    .solution-item.solution-item-text-left:hover {
        background: #ff4e00;
        color: #ffffff;
    }
    .solution-item.solution-item-text-right:hover .business-item-title {
        /*background: #ff4e00;*/
        color: #ffffff;
    }
    .solution-item.solution-item-text-left:hover .business-item-title {
        /*background: #ff4e00;*/
        color: #ffffff;
    }
    .solution-item.solution-item-text-right:hover .corner-left {
        border-right: 30px solid #ff4e00;
    }
    .solution-item.solution-item-text-left:hover .corner-rigth {
        border-left: 30px solid #ff4e00;
    }
    .solution-item-p {
        display: inline-block;
        line-height: 30px;
    }

</style>
